import { createSelector } from 'reselect';

export const getEntity = ({ entity }) => entity;
export const getEntityIsVisible = createSelector(getEntity, ({ isVisible }) => isVisible);
export const getEntityShouldRefresh = createSelector(
  getEntity,
  ({ shouldRefresh }) => shouldRefresh,
);
const getEntityData = createSelector(getEntity, ({ data }) => data);
const getEntityDataProducts = createSelector(getEntityData, ({ products }) => products);
const getEntityDataProductsL4 = createSelector(getEntityDataProducts, ({ l4 }) => l4);
const getEntityDataProductsL5 = createSelector(getEntityDataProducts, ({ l5 }) => l5);
const getEntityDataProductsConflictOfInterests = createSelector(
  getEntityDataProducts,
  ({ conflictOfInterests }) => conflictOfInterests,
);
const getEntityDataProduct = createSelector(
  getEntityDataProductsL4,
  getEntityDataProductsL5,
  (l4, l5) => (l5.available ? l5 : l4),
);
const getEntityDataProductPurchased = createSelector(
  getEntityDataProduct,
  ({ purchased }) => purchased,
);
const getEntityDataProductApproved = createSelector(
  getEntityDataProduct,
  ({ approved }) => approved,
);
export const getEntityDataProductShowRatingRequestInProgress = createSelector(
  getEntityDataProductPurchased,
  getEntityDataProductApproved,
  getEntityDataProductsConflictOfInterests,
  (purchased, approved, conflictOfInterests) => purchased && !approved && !conflictOfInterests,
);
export const getEntityDataProductsLevel = createSelector(getEntityDataProductsL5, ({ available }) =>
  available ? 'L5' : 'L4',
);
export const getEntityDataProductShowRequestRatingBox = isUltimateParentUser =>
  createSelector(getEntityDataProductPurchased, purchased =>
    isUltimateParentUser ? false : !purchased,
  );
